import { downloadOrSaveJson } from '../../services/opfs-download-service';
import { drawingObjectToGeoJson } from '../helpers/helpers';
import { DrawingObject } from './types';

export async function exportDrawingObject(object: DrawingObject) {
    const feature = drawingObjectToGeoJson(object.type, object.geometry);
    const props = feature.properties as any;
    props.name = object.name;
    props.label = object.label.text;
    const geoJson = JSON.stringify(feature);
    await downloadOrSaveJson(`object-${object.name}.json`, geoJson);
}
